import React from 'react'

export const About = () => {
  return (
    <>
    <p> This is yuvraj singh personal todo list app which is used in mobile </p>
    </>
  )
}
